import { collectionMiddleware } from 'store/middlewares/collection';
import { combinedPhotobookMiddlewares } from 'store/middlewares/photobook';

export const middlewares = [collectionMiddleware.middleware, ...combinedPhotobookMiddlewares];
